import { useState } from 'react';
import { PillButtons } from '../input';
import { CodeBlock } from './CodeBlock';

export const CodeLanguages = ({ snippets }) => {
  const [tab, setTab] = useState(snippets[0]?.name);
  const active = snippets.find((snippet) => snippet.name == tab) || snippets[0];

  if (!active) {
    return null;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <PillButtons
        value={active.name}
        onChange={setTab}
        choices={snippets.map((snippet) => [snippet.name, snippet.name])}
        pillStyle={{ width: 160, textAlign: 'center' }}
      />
      <CodeBlock language={active.language} copy code={active.code} theme="light" />
    </div>
  );
};
